/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import PropTypes from 'prop-types'
import PubSub from "pubsub-js";
import { css } from 'emotion'
import axios from 'axios'
import { AutoSuggest } from "@maxmilhas/hangar-components-atomic/public"
import { flex, airportList, switchWrapper, switchButton } from './style'

import "../../../shared/pubsub-triggers";

const getAirports = text => axios.get(`https://www.maxmilhas.com.br/airports/search/${text}`)

class AirportAutocomplete extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      outboundTextValue: props.outboundTextValue || '',
      outboundValue: props.outboundValue || '',
      outboundSelected: props.outboundSelected || null,
      outboundAirports: [],
      inboundTextValue: props.inboundTextValue || '',
      inboundValue: props.inboundValue || '',
      inboundSelected: props.inboundSelected || null,
      inboundAirports: [],
      outboundSuggestionsOpen: false,
      inboundSuggestionsOpen: false,
      hasError: {
        from: false,
        to: false,
      }
    }

    this.onOutboundChange = this.onOutboundChange.bind(this)
    this.onInboundChange = this.onInboundChange.bind(this)
    this.generateData = this.generateData.bind(this)
    this.onOutboundSuggestionSelected = this.onOutboundSuggestionSelected.bind(this)
    this.onInboundSuggestionSelected = this.onInboundSuggestionSelected.bind(this)
    this.onSwitchClick = this.onSwitchClick.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.hasError.from !== this.props.hasError.from || prevState.hasError.to !== this.props.hasError.to) {
      this.setState({ hasError: { ...this.props.hasError } });
    }
  }

  async onOutboundChange(event, { newValue, method }) {
    this.setState({
      outboundTextValue: newValue
    })

    if (newValue.length <= 2 || method !== 'type') {
      return
    }

    const response = await getAirports(newValue)

    this.setState({
      outboundAirports: response.data,
      outboundSuggestionsOpen: true
    })
  }

  async onInboundChange(event, { newValue, method }) {
    this.setState({
      inboundTextValue: newValue
    })

    if (newValue.length <= 2 || method !== 'type') {
      return
    }

    const response = await getAirports(newValue)

    this.setState({
      inboundAirports: response.data,
      inboundSuggestionsOpen: true
    })
  }

  onSwitchClick(event) {    
    const switchIcon = event.target

    if (switchIcon) {
      switchIcon.classList.toggle("switchMotion");
    }

    this.setState({
      outboundTextValue: this.state.inboundTextValue,
      outboundValue: this.state.inboundValue,
      outboundSelected: this.state.inboundSelected,
      inboundTextValue: this.state.outboundTextValue,
      inboundValue: this.state.outboundValue,
      inboundSelected: this.state.outboundSelected
    }, () => { this.props.getValue(this.generateData(this.state)) })
  }

  onOutboundSuggestionSelected(event, { suggestion }) {
    const valueText = this.formatInputText(suggestion);
    this.setState({ outboundTextValue: valueText, outboundValue: suggestion.iata, outboundSelected: suggestion }, () => {
      this.props.getValue(this.generateData(this.state))
    });
    PubSub.publish("dataLayer", {
      event: "gaEvent",
      gaEventCategory: "Ponte aérea max",
      gaEventAction: "Para onde você viaja sempre",
      gaEventLabel: "Interação com Aeroporto de Origem",
      gaEventDetail: suggestion.iata
    });
  }

  onInboundSuggestionSelected(event, { suggestion }) {
    const valueText = this.formatInputText(suggestion);
    this.setState({ inboundTextValue: valueText, inboundValue: suggestion.iata, inboundSelected: suggestion }, () => {
      this.props.getValue(this.generateData(this.state))
    });
    PubSub.publish("dataLayer", {
      event: "gaEvent",
      gaEventCategory: "Ponte aérea max",
      gaEventAction: "Para onde você viaja sempre",
      gaEventLabel: "Interação com Aeroporto de Origem",
      gaEventDetail: suggestion.iata
    });
  }

  generateData(state) {
    return ({
      outboundIata: state.outboundValue,
      outboundText: state.outboundTextValue,
      inboundIata: state.inboundValue,
      inboundText: state.inboundTextValue
    })
  }

  formatInputText(airport) {
    return airport ? `${airport.city} - ${airport.name}, (${airport.iata})` : ''
  }

  renderSuggestion = suggestion => (
    <div className={css`${airportList}`} key={suggestion}>
      <div className="airport-list-wrapper">
        <i className="icon-plane" />
        <div className="airport-content">
          <span className="airport-name">
            {suggestion.name}
          </span>
          <span className="airport-location">{suggestion.city}, {suggestion.country}</span>
        </div>
        <div className="iata">{suggestion.iata}</div>
      </div>
    </div>
  )

  render() {
    const {
      outboundTextValue,
      inboundTextValue,
      outboundAirports,
      inboundAirports,
      outboundSelected,
      inboundSelected,
      outboundSuggestionsOpen,
      inboundSuggestionsOpen,
      hasError: { from: errorFrom, to: errorTo }
    } = this.state

    return (
      <div className={css`${flex}`}>
        <div className="flex-item" data-tooltip={!outboundSuggestionsOpen && errorFrom ? errorFrom : ""} data-flow="down">
          <AutoSuggest
            icon="icon-pin"
            placeholder="Cidade ou aeroporto"
            shadow={true}
            label="Saio de"
            id="from"
            name="from"
            value={outboundTextValue}
            suggestions={outboundAirports}
            onChange={this.onOutboundChange}
            renderSuggestion={this.renderSuggestion}
            onSuggestionSelected={this.onOutboundSuggestionSelected}
            suggestionKeyValueToUse="iata"
            hasError={errorFrom}
            onFocus={() => this.setState({ outboundTextValue: '' })}
            onBlur={() => this.setState({ outboundTextValue: this.formatInputText(outboundSelected), outboundSuggestionsOpen: false, outboundAirports: [] })}
            aria-required="true"
            aria-label={errorFrom || "Digite a cidade, aeroporto ou use as setas cima e baixo do teclado para navegar entre os resultados e pressione enter para selecionar"}
            aria-invalid={typeof errorFrom === "string"}
          />
        </div>
        <div className={css`${switchWrapper}`}>
          <button
            disabled={!outboundSelected && !inboundSelected}
            type="button"
            className={css`${switchButton(!outboundSuggestionsOpen)}`}
            onClick={this.onSwitchClick}
            aria-label="Pressione para inverter aeroportos de origem e destino"
          >
            <i className="icon-arrow-two" />
          </button>
        </div>
        <div className="flex-item" data-tooltip={!inboundSuggestionsOpen && errorTo ? errorTo : ""} data-flow="down">
          <AutoSuggest
            icon="icon-pin"
            placeholder="Cidade ou aeroporto"
            shadow={true}
            label="Vou para"
            id="to"
            name="to"
            value={inboundTextValue}
            suggestions={inboundAirports}
            onChange={this.onInboundChange}
            renderSuggestion={this.renderSuggestion}
            onSuggestionSelected={this.onInboundSuggestionSelected}
            suggestionKeyValueToUse="iata"
            hasError={errorTo}
            onFocus={() => this.setState({ inboundTextValue: '' })}
            onBlur={() => this.setState({ inboundTextValue: this.formatInputText(inboundSelected), inboundSuggestionsOpen: false, inboundAirports: [] })}
            aria-required="true"
            aria-label={errorTo || "Digite a cidade, aeroporto ou use as setas cima e baixo do teclado para navegar entre os resultados e pressione enter para selecionar"}
            aria-invalid={typeof errorTo === "string"}
          />
        </div>
      </div>
    )
  }
}

AirportAutocomplete.propTypes = {

}

AirportAutocomplete.defaultProps = {

}

export default AirportAutocomplete
